// 保存token信息

// export const getItem = name => {
//   return JSON.parse(localStorage.getItem(name))
// }
// // 向localStorage中设置一项数据 名字为name里面设置值为obj
// export const setItem = (name, obj) => {
//   localStorage.setItem(name, JSON.stringify(obj))
// }
// // 删除
// export const removeitem = name => {
//   localStorage.removeItem(name)
// }


// 读取localStorage，自动处理JSON，解析失败原样返回
export const getItem = name => {
  const data = localStorage.getItem(name)
  if (!data) return null
  try {
    return JSON.parse(data)
  } catch (err) {
    // 解析失败说明不是json字符串，直接返回原值
    return data
  }
}

// 向localStorage中设置一项数据
export const setItem = (name, obj) => {
  localStorage.setItem(name, JSON.stringify(obj))
}

// 删除
export const removeitem = name => {
  localStorage.removeItem(name)
}











